import React, { useEffect, useState } from "react";
import {
  Card,
  Row,
  Col,
  Typography,
  Spin,
  Empty,
  Input,
  Button,
  Modal,
  Form,
  InputNumber,
  Upload,
  message,
  Space,
  Tooltip,
  Popconfirm,
} from "antd";
import {
  SearchOutlined,
  EditOutlined,
  DeleteOutlined,
  PlusOutlined,
  UploadOutlined,
  SaveOutlined,
  CloseOutlined,
} from "@ant-design/icons";
import { deleteServiceApi, getServiceApi, updateServiceApi } from "../../services/serviceApi";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

const { Title, Text } = Typography;
const { Search } = Input;

// Mock API functions - replace with your actual APIs





export default function ServiceListView() {
  const [services, setServices] = useState([]);
  const [filteredServices, setFilteredServices] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [editModalVisible, setEditModalVisible] = useState(false);
  const [editingService, setEditingService] = useState(null);
  const [editForm] = Form.useForm();
  const [editLoading, setEditLoading] = useState(false);
  const [newImage, setNewImage] = useState(null);
  const [newImagePreview, setNewImagePreview] = useState("");
  const navigate = useNavigate()
const {tenantId,companyId} = useParams()
  useEffect(() => {
    fetchServices();
  }, []);

  const fetchServices = async () => {
    try {
      setLoading(true);
      const res = await getServiceApi({companyId:companyId});
      setServices(res || []);
      setFilteredServices(res || []);
    } catch (err) {
      console.error("Error fetching services", err);
      message.error("Failed to fetch services");
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = (value) => {
    const keyword = value.trim().toLowerCase();
    setSearchValue(value);
    
    if (!keyword) {
      setFilteredServices(services);
      return;
    }

    const filtered = services.filter((service) =>
      service.name.toLowerCase().includes(keyword)
    );
    setFilteredServices(filtered);
  };

  const handleEdit = (service) => {
    setEditingService(service);
    setNewImagePreview(service.image?.fileUrl || "");
    editForm.setFieldsValue({
      name: service.name,
      price: service.price,
    });
    setEditModalVisible(true);
  };

  const handleEditSubmit = async (values) => {
    try {
      setEditLoading(true);
      
      const formData = new FormData();
      formData.append('name', values.name);
      formData.append('price', values.price);
      
      if (newImage) {
        formData.append('image', newImage);
      }

      const res = await updateServiceApi(editingService._id, values);
      
      if (!res?.sucess) {
        toast.error(res?.message || 'Failed to update service');
        return;
      }

      toast.success("Service updated successfully!");
      setEditModalVisible(false);
      fetchServices(); // Refresh the list
      
    } catch (err) {
      console.error('Update error:', err);
      message.error("Failed to update service");
    } finally {
      setEditLoading(false);
    }
  };

  const handleDelete = async (serviceId) => {
    console.log(serviceId,"delete ")
    try {
          const res = await deleteServiceApi(serviceId);
          if (res?.sucess) {
            toast.success("Service deleted successfully!");
            fetchServices(); // Refresh the list
          }
        } catch (err) {
          message.error("Failed to delete service");
        }
  };

  const beforeUpload = (file) => {
    const isValidType = ["image/jpeg", "image/jpg", "image/png", "image/gif", "image/webp"].includes(file.type);
    if (!isValidType) {
      message.error("Please upload a valid image file");
      return false;
    }

    const isLt5M = file.size / 1024 / 1024 < 5;
    if (!isLt5M) {
      message.error("Image size must be less than 5MB!");
      return false;
    }

    // Create preview
    const reader = new FileReader();
    reader.onload = (e) => {
      setNewImagePreview(e.target.result);
    };
    reader.readAsDataURL(file);

    setNewImage(file);
    return false;
  };

  const getServiceImage = (service) => {
    return service.image?.fileUrl || null;
  };

  const ServiceCard = ({ service }) => {
    const imageUrl = getServiceImage(service);
    const [imgError, setImgError] = useState(false);
    const hasValidImage = Boolean(imageUrl && !imgError);

    return (
      <Card
        hoverable
        style={{
          borderRadius: '16px',
          overflow: 'hidden',
          border: 'none',
          boxShadow: '0 8px 32px rgba(0,0,0,0.1)',
          transition: 'all 0.3s ease',
          height: '100%',
        }}
        bodyStyle={{ padding: 0 }}
        cover={
          <div style={{ 
            position: 'relative', 
            height: '240px',
            background: hasValidImage 
              ? '#f0f2f5' 
              : 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            overflow: 'hidden'
          }}>
            {hasValidImage ? (
              <img
                src={imageUrl}
                alt={service.name}
                onError={() => setImgError(true)}
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                  transition: 'transform 0.3s ease',
                }}
                onMouseEnter={(e) => e.target.style.transform = 'scale(1.05)'}
                onMouseLeave={(e) => e.target.style.transform = 'scale(1)'}
              />
            ) : (
              <div style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                height: '100%',
                color: 'white',
                textAlign: 'center'
              }}>
                <div style={{
                  width: '80px',
                  height: '80px',
                  borderRadius: '50%',
                  background: 'rgba(255,255,255,0.2)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginBottom: '16px'
                }}>
                  <span style={{ fontSize: '32px', fontWeight: 'bold' }}>
                    {service.name ? service.name.charAt(0).toUpperCase() : 'S'}
                  </span>
                </div>
                <Text style={{ color: 'white', fontSize: '14px', opacity: 0.8 }}>
                  No Image
                </Text>
              </div>
            )}
            
            {/* Action Buttons Overlay */}
            <div style={{
              position: 'absolute',
              top: '12px',
              right: '12px',
              display: 'flex',
              gap: '8px',
              zIndex: 10,
            }}
            className="card-actions"
            >
              <Tooltip title="Edit Service">
                <Button
                  type="primary"
                  shape="circle"
                  icon={<EditOutlined style={{ color: '#ffffff', fontSize: '14px' }} />}
                  size="small"
                  onClick={() => handleEdit(service)}
                  style={{
                    background: '#1890ff',
                    border: 'none',
                    boxShadow: '0 2px 8px rgba(24,144,255,0.4)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '32px',
                    height: '32px',
                  }}
                />
              </Tooltip>
              <Tooltip title="Delete Service">
                <Popconfirm
                  title="Delete Service"
                  description="Are you sure you want to delete this service?"
                  onConfirm={() => handleDelete(service._id)}
                  okText="Yes"
                  cancelText="No"
                  okButtonProps={{ danger: true }}
                >
                  <Button
                    type="primary"
                    danger
                    shape="circle"
                    icon={<DeleteOutlined style={{ color: '#ffffff', fontSize: '14px' }} />}
                    size="small"
                    style={{
                      background: '#ff4d4f',
                      border: 'none',
                      boxShadow: '0 2px 8px rgba(255,77,79,0.4)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      width: '32px',
                      height: '32px',
                    }}
                  />
                </Popconfirm>
              </Tooltip>
            </div>

            {/* Price Badge */}
            <div style={{
              position: 'absolute',
              bottom: '12px',
              left: '12px',
              background: 'rgba(0,0,0,0.8)',
              color: 'white',
              padding: '8px 16px',
              borderRadius: '20px',
              fontSize: '16px',
              fontWeight: 'bold',
              backdropFilter: 'blur(4px)'
            }}>
              ₹{service.price}
            </div>
          </div>
        }
      >
        <div style={{ padding: '20px' }}>
          <Title level={4} style={{ 
            marginBottom: '8px',
            color: '#1a1a1a',
            fontSize: '18px',
            lineHeight: '1.4'
          }}>
            {service.name}
          </Title>
          
          <Text type="secondary" style={{ fontSize: '14px' }}>
            Added {new Date(service.createdAt).toLocaleDateString('en-US', {
              month: 'short',
              day: 'numeric',
              year: 'numeric'
            })}
          </Text>
        </div>
      </Card>
    );
  };


  return (
    <div style={{ 
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
      padding: '24px'
    }}>
      <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
        {/* Header */}
        <div style={{
          background: 'white',
          borderRadius: '20px',
          padding: '32px',
          marginBottom: '24px',
          boxShadow: '0 8px 32px rgba(0,0,0,0.1)'
        }}>
          <Title level={2} style={{ 
            margin: 0,
            marginBottom: '8px',
            background: 'linear-gradient(45deg, #1890ff, #722ed1)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            fontSize: '32px'
          }}>
            Service Collection
          </Title>
          <Text type="secondary" style={{ fontSize: '16px' }}>
            Manage your service offerings with ease
          </Text>
        </div>

        {/* Search & Stats */}
        <div style={{
          background: 'white',
          borderRadius: '20px',
          padding: '24px',
          marginBottom: '24px',
          boxShadow: '0 8px 32px rgba(0,0,0,0.1)'
        }}>
          <Row align="middle" gutter={[16, 16]}>
            <Col xs={24} md={16}>
              <Search
                placeholder="Search services..."
                size="large"
                prefix={<SearchOutlined />}
                value={searchValue}
                onChange={(e) => handleSearch(e.target.value)}
                style={{ borderRadius: '12px' }}
                allowClear
              />
            </Col>
            <Col xs={24} md={8} style={{ textAlign: 'right' }}>
              <Space>
                <div style={{
                  background: 'linear-gradient(45deg, #1890ff, #722ed1)',
                  color: 'white',
                  padding: '8px 16px',
                  borderRadius: '20px',
                  fontSize: '14px',
                  fontWeight: 'bold'
                }}>
                  {filteredServices.length} Services
                </div>
                <Button 
                  type="primary" 
                  icon={<PlusOutlined />}
                  style={{ borderRadius: '8px' }}
                  onClick={()=> navigate(`/company/${companyId}/service/create`)}
                >
                  Add Service
                </Button>
              </Space>
            </Col>
          </Row>
        </div>

        {/* Services Grid */}
        <div>
          {loading ? (
            <div style={{ 
              textAlign: 'center', 
              padding: '80px 0',
              background: 'white',
              borderRadius: '20px',
              boxShadow: '0 8px 32px rgba(0,0,0,0.1)'
            }}>
              <Spin size="large" />
              <div style={{ marginTop: '16px' }}>
                <Text type="secondary">Loading services...</Text>
              </div>
            </div>
          ) : filteredServices.length === 0 ? (
            <div style={{ 
              textAlign: 'center', 
              padding: '80px 0',
              background: 'white',
              borderRadius: '20px',
              boxShadow: '0 8px 32px rgba(0,0,0,0.1)'
            }}>
              <Empty 
                description={
                  searchValue 
                    ? `No services found for "${searchValue}"` 
                    : "No services available"
                }
                image={Empty.PRESENTED_IMAGE_SIMPLE}
              />
              {searchValue && (
                <Button 
                  type="primary" 
                  onClick={() => {
                    setSearchValue('');
                    setFilteredServices(services);
                  }}
                  style={{ marginTop: '16px', borderRadius: '8px' }}
                >
                  Clear Search
                </Button>
              )}
            </div>
          ) : (
            <Row gutter={[24, 24]}>
              {filteredServices.map((service) => (
                <Col xs={24} sm={12} md={8} lg={6} key={service._id}>
                  <ServiceCard service={service} />
                </Col>
              ))}
            </Row>
          )}
        </div>
      </div>

      {/* Edit Modal */}
      <Modal
        title={
          <div style={{ fontSize: '20px', fontWeight: 'bold' }}>
            <EditOutlined style={{ marginRight: '8px', color: '#1890ff' }} />
            Edit Service
          </div>
        }
        open={editModalVisible}
        onCancel={() => {
          setEditModalVisible(false);
          setNewImage(null);
          setNewImagePreview("");
          editForm.resetFields();
        }}
        footer={null}
        width={600}
        style={{ borderRadius: '16px' }}
      >
        <Form
          form={editForm}
          layout="vertical"
          onFinish={handleEditSubmit}
          style={{ marginTop: '24px' }}
        >
          <Form.Item
            label={<Text strong>Service Name</Text>}
            name="name"
            rules={[
              { required: true, message: "Please enter service name" },
              { min: 2, message: "Name must be at least 2 characters" }
            ]}
          >
            <Input 
              placeholder="Enter service name"
              size="large"
              style={{ borderRadius: '8px' }}
            />
          </Form.Item>

          <Form.Item
            label={<Text strong>Price</Text>}
            name="price"
            rules={[
              { required: true, message: "Please enter price" },
              { type: 'number', min: 0.01, message: "Price must be greater than 0" }
            ]}
          >
            <InputNumber
              style={{ width: "100%", borderRadius: '8px' }}
              size="large"
              min={0}
              step={0.01}
              placeholder="0.00"
              prefix="₹"
              formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
              parser={value => value.replace(/₹\s?|(,*)/g, '')}
            />
          </Form.Item>

          {/* <Form.Item
            label={<Text strong>Service Image</Text>}
          >
            {newImagePreview ? (
              <div style={{ marginBottom: '16px' }}>
                <div style={{ position: 'relative', display: 'inline-block' }}>
                  <img
                    src={newImagePreview}
                    alt="Preview"
                    style={{
                      width: '200px',
                      height: '120px',
                      objectFit: 'cover',
                      borderRadius: '8px',
                      border: '1px solid #d9d9d9'
                    }}
                  />
                  <Button
                    type="text"
                    danger
                    icon={<CloseOutlined />}
                    size="small"
                    onClick={() => {
                      setNewImage(null);
                      setNewImagePreview("");
                    }}
                    style={{
                      position: 'absolute',
                      top: '4px',
                      right: '4px',
                      background: 'rgba(255,255,255,0.9)'
                    }}
                  />
                </div>
              </div>
            ) : null}
            
            <Upload
              beforeUpload={beforeUpload}
              showUploadList={false}
              accept="image/*"
            >
              <Button 
                icon={<UploadOutlined />} 
                style={{ borderRadius: '8px' }}
              >
                {newImagePreview ? 'Change Image' : 'Upload Image'}
              </Button>
            </Upload>
            <div style={{ marginTop: '8px' }}>
              <Text type="secondary" style={{ fontSize: '12px' }}>
                Max 5MB. Supports JPEG, PNG, GIF, WebP
              </Text>
            </div>
          </Form.Item> */}

          <Form.Item style={{ marginBottom: 0, marginTop: '32px' }}>
            <Space style={{ width: '100%', justifyContent: 'flex-end' }}>
              <Button 
                onClick={() => {
                  setEditModalVisible(false);
                  setNewImage(null);
                  setNewImagePreview("");
                  editForm.resetFields();
                }}
                style={{ borderRadius: '8px' }}
              >
                Cancel
              </Button>
              <Button
                type="primary"
                htmlType="submit"
                loading={editLoading}
                icon={<SaveOutlined />}
                style={{ borderRadius: '8px' }}
              >
                {editLoading ? 'Updating...' : 'Update Service'}
              </Button>
            </Space>
          </Form.Item>
        </Form>
      </Modal>

      <style>{`
        .card-actions {
          opacity: 0.95;
          transition: all 0.2s ease-in-out;
        }
        .ant-card:hover .card-actions {
          opacity: 1 !important;
          transform: scale(1.02);
        }
      `}</style>
    </div>
  );
}